import { Box, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { getDeepViewLineageEntry } from "../../deepViewFieldMap";

interface Props {
  /** API key of the column the user clicked, e.g. "total_income_usd" */
  columnKey?: string;
}

const InputField = ({ columnKey }: Props) => {
  const deepViewData = useSelector(
    (state: any) => state?.deepView?.deepViewData,
  );
  const lineageEntry = getDeepViewLineageEntry(deepViewData, columnKey);

  // Only fields fed by a gap rule read other fields as inputs
  if (!lineageEntry?.gap_rule_dependency_fields) return null;

  const deps = lineageEntry?.deps ?? [];

  return (
    <>
      {deps.map((dep: any, index: number) => {
        const rows = [
          { label: "Source Field", value: dep?.source_field, mono: true },
          { label: "Raw Table", value: dep?.raw_table_name, mono: true },
          {
            label: "Interface",
            value: lineageEntry?.fetcher_interface_name,
            mono: false,
          },
          {
            label: "Collection",
            value: lineageEntry?.collection_type_name,
            mono: true,
          },
        ];

        return (
          <Box
            key={dep?.field_key ?? index}
            sx={{
              border: "1px solid #E0E0E0",
              borderLeft: "3px solid #9C27B0",
              borderRadius: "8px",
              overflow: "hidden",
              mt: 1,
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{
                backgroundColor: "#9C27B00A",
                px: 1.5,
                py: 1,
              }}
            >
              <Box
                sx={{
                  border: "1px solid #9C27B080",
                  borderRadius: "4px",
                  backgroundColor: "#FFFFFF",
                  color: "#7B1FA2",
                  fontSize: "10px",
                  fontWeight: 500,
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  px: 0.5,
                  py: "1px",
                  whiteSpace: "nowrap",
                }}
              >
                Input field
              </Box>

              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "#000000DE",
                  textTransform: "uppercase",
                }}
              >
                {dep?.field_key}
              </Typography>
            </Stack>

            {rows.map((row) => (
              <Stack
                key={row.label}
                direction="row"
                alignItems="center"
                sx={{
                  px: 1.5,
                  py: 1,
                  borderTop: "1px solid #F0F0F0",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <Typography
                  sx={{
                    width: 110,
                    flexShrink: 0,
                    fontSize: "11px",
                    fontWeight: 500,
                    color: "#00000099",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  {row.label}
                </Typography>

                <Typography
                  sx={{
                    fontSize: "12px",
                    ...(row.mono
                      ? {
                          fontFamily: "monospace",
                          fontWeight: 700,
                          color: "#7B1FA2",
                        }
                      : { color: "#000000DE" }),
                  }}
                >
                  {row.value ?? "-"}
                </Typography>
              </Stack>
            ))}
          </Box>
        );
      })}
    </>
  );
};

export default InputField;
